import { Movement, Range } from 'types';

import { removeRangeFromRange } from 'utils/removeRangeFromRange';

import movementTypes from 'modules/transactions/constants/movementTypes';
import { createMovement } from 'modules/transactions/utils/createMovement';

import { isRangeFullyCovered } from './simulateSharesTransferLedger';

type BuildSellerTransferMovementsParams = {
  partnerSellerId: string;
  holdingClassId: string;
  shareFrom: number;
  shareTo: number;
  availableRanges: Range[];
};

export const buildSellerTransferMovements = ({
  partnerSellerId,
  holdingClassId,
  shareFrom,
  shareTo,
  availableRanges,
}: BuildSellerTransferMovementsParams): Movement[] => {
  const overlappingRanges = availableRanges.filter(
    (range) => range.to >= shareFrom && range.from <= shareTo
  );

  const covered = isRangeFullyCovered(
    overlappingRanges.map((range) => ({
      from: range.from,
      to: range.to,
      shareClass: holdingClassId,
      encumbrances: range.encumbrances,
    })),
    shareFrom,
    shareTo
  );

  if (!covered) {
    return [];
  }

  const transferRange: Range = {
    from: shareFrom,
    to: shareTo,
    partner: partnerSellerId,
    shareClass: holdingClassId,
  };

  const movements: Movement[] = [];

  overlappingRanges.forEach((fragment) => {
    const removedRange: Range = {
      from: fragment.from,
      to: fragment.to,
      partner: partnerSellerId,
      shareClass: holdingClassId,
      encumbrances: fragment.encumbrances || [],
    };

    const leftoverRanges = removeRangeFromRange(transferRange, removedRange);

    movements.push(
      createMovement({
        range: removedRange,
        movementType: movementTypes.DECREMENT,
      }) as Movement
    );

    leftoverRanges.forEach((leftoverRange) => {
      movements.push(
        createMovement({
          range: {
            ...leftoverRange,
            partner: partnerSellerId,
            shareClass: holdingClassId,
          },
          movementType: movementTypes.INCREMENT,
        }) as Movement
      );
    });
  });

  return movements;
};
